module.exports = __webpack_public_path__ + "static/dhergoloth-5bf9534361273cb8b384c9a8d3e149ba.png";